const mixin = {
  methods: {
    isIOS() {
      return (
        (/iPad|iPhone|iPod/.test(navigator.platform) ||
          (navigator.platform === 'MacIntel' &&
            navigator.maxTouchPoints > 1)) &&
        !window.MSStream
      );
    },
  },
};

export default mixin;
